import {
  GET_GOAL_STATUS_CONFIG,
  SET_GOAL_STATUS_CONFIG_LOADING,
} from "actions/constants";

const initialState = {
  goalStatusConfig: null,
  loading: false,
};

const goalStatusConfig = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOAL_STATUS_CONFIG: {
      return {
        ...state,
        goalStatusConfig: action.payload,
      };
    }

    case SET_GOAL_STATUS_CONFIG_LOADING: {
      return {
        ...state,
        loading: action.payload.loading,
      };
    }

    default:
      return state;
  }
};

export default goalStatusConfig;
